import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _ImportLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { fill: "currentColor", d: "m12 14-.354.354.354.353.354-.353zm.5-9a.5.5 0 0 0-1 0zM6.646 9.354l5 5 .708-.708-5-5zm5.708 5 5-5-.708-.708-5 5zM12.5 14V5h-1v9z" }), _jsx("path", { stroke: "currentColor", d: "M5 16v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1" })] }) });
}
const ImportLight = forwardRef(_ImportLight);
export { ImportLight };
